import { Container, ContainerProps } from '@mui/material'
import { CONTENT_MAX_WIDTH, CONTENT_PADDING_X, SPACE } from '../styles/layout'

const ZScreenContainer = (props: ContainerProps) => {
  const { children, style, sx, ...rest } = props

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        maxWidth: CONTENT_MAX_WIDTH,
        paddingLeft: CONTENT_PADDING_X,
        paddingRight: CONTENT_PADDING_X,
        ...(sx as object),
      }}
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: SPACE.xl,
        height: '100%',
        width: '100%',
        margin: '0 auto',
        alignItems: 'center',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default ZScreenContainer
